// extracted by mini-css-extract-plugin
export default {"main":"ReviewCoursePage_main__E12+H"};